import React from 'react';
import { NewsAboutContainer } from '../../containers/news/NewsAboutContainer';
import { logNewsEvent } from '../../services/news';

export const NewsAboutPage = () => {
    logNewsEvent("About");
    return <NewsAboutContainer />;
}
